import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useGlobalState } from '../common/context/AppContext';
import { IAppProps } from '../common/interface/IAppProvider';
import { ROUTE_NAMES } from './RouterApp';
import { removeSessionItem } from '../common/services/StorageService';

export default function RouterCondition(props: IAppProps): JSX.Element {
    const globalState = useGlobalState();
    const location = useLocation();
    const isReceipt = props.config.baseName.indexOf('kvittering') !== -1;
    // User didn't start the flow and trying to jump to the middle. He must go to the start.
    if (globalState.initialState && location.pathname !== ROUTE_NAMES.CVR) {
        return <Navigate to={ROUTE_NAMES.CVR} />;
    }
    if (isReceipt && !globalState.validReceiptRedirection) {
        removeSessionItem('onsa-b2b-session-key');
        const endsWithSlash = /\/$/;
        let bn = props.config.baseName.match(endsWithSlash)
            ? props.config.baseName.slice(0, -1)
            : props.config.baseName;
        window.location.assign(bn.substring(0, bn.lastIndexOf('/') + 1));
    }

    return <Outlet />;
}
